// dashboard
//import Ecommerce from "pages/Dashboards/Ecommerce";

import UserProfile from "pages/Authentication/UserProfile";
import Login from "pages/Authentication/Login";
import Register from "pages/Authentication/Register";
import { lazy } from "react";
import OptionsMenus from "pages/Security/OptionsMenus";

const Ecommerce = lazy(() => import("pages/Dashboards/Ecommerce"));
const ResetPassword = lazy(() => import("pages/Authentication/ResetPassword"));
const Roles = lazy(() => import("pages/Security/roles/Roles"));
const Customers = lazy(() => import("pages/Configuration/Customers/Customers"));
const InventoryAdjustment = lazy(() => import("pages/Products/InventoryAdjustment/InventoryAdjustment"));
const ListPurchaseReport = lazy(() => import("pages/Reports/ListPurchaseReport/ListPurchaseReport"));
const ListTransferReport = lazy(() => import("pages/Reports/ListTransferReport/ListTransferReport"));
const ListAdjustmentsReport = lazy(() => import("pages/Reports/ListAdjustmentsReport/ListAdjustmentsReport"));
const ListQuotesReportView = lazy(() => import("pages/Reports/ListQuotesReport/ListQuotesReport"));
const ListSalesReportView = lazy(() => import("pages/Reports/ListSalesReport/ListSalesReport"));
const ListExistencesReportView = lazy(() => import("pages/Reports/ListExistencesReport/ListExistencesReport"));
const ListStateCountBycustomerView = lazy(() => import("pages/Reports/ListStateCountBycustomer/ListStateCountBycustomerReport"));
const ListArticleListaReport = lazy( () => import("pages/Reports/ListArticlesReport/ListArticleReport") );
const ListSalesgraphView = lazy(() => import("pages/Reports/ListSalesgraph/ListSalesgraph"));
const ListCollectionsgraphView = lazy(() => import("pages/Reports/ListCollectionsgraph/ListCollectionsgraph"));
const ListEarningsgraphView = lazy(() => import("pages/Reports/ListEarningsgraph/ListEarningsgraph"));
const ListDaysInWarehouseView = lazy(() => import("pages/Reports/ListDaysInWarehouse/ListDaysInWarehouse"));
const ListCashRegisterClosingReport = lazy( () => import("pages/Reports/ListCashRegisterClosingReport/listCashRegisterClosingReport"))
const DasboradInformation = lazy( () => import("pages/Dashboards/DasboardInformation/DashboardInformatrionView"));




const Warehouses = lazy(
  () => import("pages/Configuration/warehouse/ListWarehouse")
);

//* Security Imports
const EmployeList = lazy(
  () => import("pages/Security/create-employe/EmployeList")
);
const MenuList = lazy(() => import("pages/Security/create-menus/ListMenu"));

const Permissions = lazy(
  () => import("pages/Security/permissions/Permissions")
);

const SpecialPermissions = lazy(
  () => import("pages/Security/create-specialpermissions/SpecialPermissions")
);
const AssigmentSpecialPermissions = lazy(
  () =>
    import(
      "pages/Security/assigment-specialpermission/AssigmentSpecialPermission"
    )
);
const CreateUserListView = lazy(
  () => import("pages/Security/create-user-type/UserType")
);

//* Configuration
const Correlativo = lazy(
  () => import("pages/Configuration/Correlativos/Correlativos")
);
const Regions = lazy(() => import("pages/Configuration/Regions/Regions"));
const Brands = lazy(() => import("pages/Configuration/Brands/Brands"));

const CustomerType = lazy(() => import("pages/CustomerTypes/CustomerTypes"))

//* products
const PClassificationListview = lazy(
  () => import("pages/Products/productsClassificatrion/ProductsClassification")
);
const Productsview = lazy(
  () => import('pages/Products/Products/Products')
);

const SupplierPayment = lazy(
  () => import("pages/Products/supplierPayment/SupplierPayment")
);
const CollectionsReceipts = lazy(
  () => import('pages/Products/CollectionsReceipts/CollectionsReceipts')
);

const Branch = lazy(() => import("pages/Configuration/create-branch/Branch"));
const CreateViewCompany = lazy(
  () => import("pages/Configuration/create-company/Company")
);


const CreateViewProvider = lazy(() => import("pages/Configuration/create-provider/Provider"));

const Departament = lazy(
  () => import("pages/Configuration/create-departament/Departament")
);

const TransferBetweenWarehouses = lazy(
  () =>
    import("pages/Products/transferBetweenWarehouse/TransferBetweenWarehouse")
);

const Municipality = lazy(
  () => import("pages/Configuration/create-municipality/Municipality")
);

//shopping
const purchaseRegistration = lazy(() => import("pages/Purchase/PurchasingRegistration/PurchasingRegistration"));
const purchaseOrders = lazy(
  () => import('pages/Purchase/PurchaseOrders/PurchaseOrder')
);

const Billing = lazy(() => import("pages/Purchase/Billing/Billing"));

const ShopingProducts = lazy( () => import("pages/Purchase/shoppingProducts/shoppingProducutsView"))



//Quotes
const QuotesRegistration = lazy(
  () => import('pages/Sales/Quotes/Quotes')
);

interface RouteObject {
  path: string;
  component: React.ComponentType<any>;
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  { path: '/', component: DasboradInformation },
  
  { path: '/home', component: DasboradInformation },

  // Security
  { path: '/user-profile', component: UserProfile },
  { path: '/create-employe', component: EmployeList },
  { path: '/permissions', component: Permissions },
  { path: '/options-menus', component: OptionsMenus },
  { path: '/create-menus', component: MenuList },
  { path: '/special-permissions', component: SpecialPermissions },
  {
    path: '/assigment-special-permissions',
    component: AssigmentSpecialPermissions,
  },
  { path: '/create-user-type', component: CreateUserListView },

  { path: '/create-branch', component: Branch },

  {
    path: '/assigment-special-permissions',
    component: AssigmentSpecialPermissions,
  },
  { path: '/roles', component: Roles },

  //Configuration
  { path: '/create-user-type', component: CreateUserListView },
  { path: '/correlativos', component: Correlativo },
  { path: '/create-departament', component: Departament },
  { path: '/create-municipality', component: Municipality },
  { path: '/warehouse', component: Warehouses },
  { path: '/regions', component: Regions },
  { path: '/create-company', component: CreateViewCompany },
  { path: '/brands', component: Brands },
  { path: '/customerTypes', component: CustomerType },
  { path: '/customers', component: Customers },

  { path: '/providers', component: CreateViewProvider },

  //Products
  { path: '/productClassificaction', component: PClassificationListview },
  { path: '/paymet-supplier', component: SupplierPayment },
  { path: '/products', component: Productsview },
  { path: '/inventoryAdjustment', component: InventoryAdjustment },
  { path: '/collectionsReceipts', component: CollectionsReceipts },

  //shopping
  { path: '/purchasingRegistration', component: purchaseRegistration },
  { path: '/purchasingOrders', component: purchaseOrders },

  {
    path: '/transfer-between-warehouses',
    component: TransferBetweenWarehouses,
  },

  {
    path: '/Billing',
    component: Billing,
  },
  {
    path: '/ShopingProducts',
    component: ShopingProducts,
  },

  //sales
  { path: '/quotationRecord', component: QuotesRegistration },


  //Reports
{ path: '/listPurchaseReport', component: ListPurchaseReport },
{ path: '/listTransferReport', component: ListTransferReport },
{ path: '/listAdjustmentsReport', component: ListAdjustmentsReport },
{ path: '/listQuotesReport', component: ListQuotesReportView },
{ path: '/listSalesReport', component: ListSalesReportView },
{ path: '/listExistencesReport', component: ListExistencesReportView },
{ path: '/listStateCountBycustomerView', component: ListStateCountBycustomerView },
{ path: '/ListArticleReportView', component: ListArticleListaReport},
{ path: '/listSalesgraphView', component: ListSalesgraphView },
{ path: '/listCollectionsgraphView', component: ListCollectionsgraphView },
{ path: '/listEarningsgraphView', component: ListEarningsgraphView },
{ path: '/listDaysInWarehouse', component: ListDaysInWarehouseView },
{ path: '/listCashRegisterReport', component: ListCashRegisterClosingReport },
];

const publicRoutes = [
  // authentication
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/reset-password", component: ResetPassword },
];

export { authProtectedRoutes, publicRoutes };